import { FC } from "react";

import { Box, ThemeUIStyleObject } from "@theme/components/ThemeUi";

export interface FieldLabelProps {
  label: string;
  error?: boolean | string;
  "data-testid"?: string;
  className?: string;
  sx?: ThemeUIStyleObject;
}

export const FieldLabel: FC<FieldLabelProps> = ({
  label,
  error = false,
  "data-testid": dataTestId,
  className,
  sx,
}) => (
  <Box
    className={className}
    data-role="label"
    data-testid={dataTestId}
    sx={{
      variant: "forms.fieldLabel",
      color: error ? "textError" : "textLevel3",
      mb: "s200",
      ...sx,
    }}
  >
    {label}
  </Box>
);
